import React from 'react';

import type { COLOR } from '#@/shared/utils/styles';

import AddContact from './icons/AddContact.svg?react';
import Alert from './icons/Alert.svg?react';
import AlertFat from './icons/AlertFat.svg?react';
import AlignCenter from './icons/AlignCenter.svg?react';
import AlignJustify from './icons/AlignJustify.svg?react';
import AlignLeft from './icons/AlignLeft.svg?react';
import AlignRight from './icons/AlignRight.svg?react';
import Archive from './icons/Archive.svg?react';
import ArrowDown from './icons/ArrowDown.svg?react';
import ArrowLeft from './icons/ArrowLeft.svg?react';
import ArrowRight from './icons/ArrowRight.svg?react';
import ArrowUp from './icons/ArrowUp.svg?react';
import BarChart from './icons/BarChart.svg?react';
import Bell from './icons/Bell.svg?react';
import BellStrikethrough from './icons/BellStrikethrough.svg?react';
import BidSubmittedWithBoQ from './icons/BidSubmittedWithBoQ.svg?react';
import BidUpToDate from './icons/BidUpToDate.svg?react';
import Bold from './icons/Bold.svg?react';
import Bookmark from './icons/Bookmark.svg?react';
import Briefcase from './icons/Briefcase.svg?react';
import Bulb from './icons/Bulb.svg?react';
import BulletList from './icons/BulletList.svg?react';
import Calendar from './icons/Calendar.svg?react';
import Camera from './icons/Camera.svg?react';
import Certificate from './icons/Certificate.svg?react';
import Check from './icons/Check.svg?react';
import CheckCircle from './icons/CheckCircle.svg?react';
import CheckFat from './icons/CheckFat.svg?react';
import Checkmark from './icons/Checkmark.svg?react';
import ChevronDown from './icons/ChevronDown.svg?react';
import ChevronDownUp from './icons/ChevronDownUp.svg?react';
import ChevronLeft from './icons/ChevronLeft.svg?react';
import ChevronRight from './icons/ChevronRight.svg?react';
import ChevronUp from './icons/ChevronUp.svg?react';
import ChevronUpDown from './icons/ChevronUpDown.svg?react';
import Clipboard from './icons/Clipboard.svg?react';
import Clock from './icons/Clock.svg?react';
import Close from './icons/Close.svg?react';
import CloseFat from './icons/CloseFat.svg?react';
import CompanyLogo from './icons/CompanyLogo.svg?react';
import Copy from './icons/Copy.svg?react';
import Cut from './icons/Cut.svg?react';
import Delete from './icons/Delete.svg?react';
import DescriptionFold from './icons/DescriptionFold.svg?react';
import DescriptionUnfold from './icons/DescriptionUnfold.svg?react';
import Diamond from './icons/Diamond.svg?react';
import DocumentCheck from './icons/DocumentCheck.svg?react';
import DoubleCheck from './icons/DoubleCheck.svg?react';
import Download from './icons/Download.svg?react';
import DragHandle from './icons/DragHandle.svg?react';
import Edit from './icons/Edit.svg?react';
import Email from './icons/Email.svg?react';
import EmailOpen from './icons/EmailOpen.svg?react';
import Empty from './icons/Empty.svg?react';
import Euro from './icons/Euro.svg?react';
import ExclamationFat from './icons/ExclamationFat.svg?react';
import ExternalLink from './icons/ExternalLink.svg?react';
import Eye from './icons/Eye.svg?react';
import EyeOff from './icons/EyeOff.svg?react';
import File from './icons/File.svg?react';
import FileEuro from './icons/FileEuro.svg?react';
import FilePlus from './icons/FilePlus.svg?react';
import FileText from './icons/FileText.svg?react';
import Filter from './icons/Filter.svg?react';
import Folder from './icons/Folder.svg?react';
import FolderOpened from './icons/FolderOpened.svg?react';
import FormalCheck from './icons/FormalCheck.svg?react';
import Gavel from './icons/Gavel.svg?react';
import Gift from './icons/Gift.svg?react';
import Globe from './icons/Globe.svg?react';
import GraphUp from './icons/GraphUp.svg?react';
import HardDrive from './icons/HardDrive.svg?react';
import Help from './icons/Help.svg?react';
import House from './icons/House.svg?react';
import Ignore from './icons/Ignore.svg?react';
import Image from './icons/Image.svg?react';
import Import from './icons/Import.svg?react';
import IndentDecrease from './icons/IndentDecrease.svg?react';
import IndentIncrease from './icons/IndentIncrease.svg?react';
import Info from './icons/Info.svg?react';
import Italic from './icons/Italic.svg?react';
import Library from './icons/Library.svg?react';
import LineSpacing from './icons/LineSpacing.svg?react';
import Link from './icons/Link.svg?react';
import Location from './icons/Location.svg?react';
import Lock from './icons/Lock.svg?react';
import MagicWand from './icons/MagicWand.svg?react';
import Marketplace from './icons/Marketplace.svg?react';
import MarketplaceActive from './icons/MarketplaceActive.svg?react';
import MathOperations from './icons/MathOperations.svg?react';
import MathOperationsFilled from './icons/MathOperationsFilled.svg?react';
import Maximize from './icons/Maximize.svg?react';
import Merge from './icons/Merge.svg?react';
import Message from './icons/Message.svg?react';
import Minus from './icons/Minus.svg?react';
import MinusFat from './icons/MinusFat.svg?react';
import More from './icons/More.svg?react';
import Move from './icons/Move.svg?react';
import Navigation from './icons/Navigation.svg?react';
import NumberedList from './icons/NumberedList.svg?react';
import Paperclip from './icons/Paperclip.svg?react';
import Payment from './icons/Payment.svg?react';
import People from './icons/People.svg?react';
import Person from './icons/Person.svg?react';
import Phone from './icons/Phone.svg?react';
import Play from './icons/Play.svg?react';
import Plus from './icons/Plus.svg?react';
import Position from './icons/Position.svg?react';
import Printer from './icons/Printer.svg?react';
import ProfileIdCard from './icons/ProfileIdCard.svg?react';
import Project from './icons/Project.svg?react';
import Publish from './icons/Publish.svg?react';
import Refresh from './icons/Refresh.svg?react';
import Reset from './icons/Reset.svg?react';
import RocketLaunch from './icons/RocketLaunch.svg?react';
import RoundedSquare from './icons/RoundedSquare.svg?react';
import Search from './icons/Search.svg?react';
import SettingsFilled from './icons/SettingsFilled.svg?react';
import SettingsOutline from './icons/SettingsOutline.svg?react';
import Share from './icons/Share.svg?react';
import Shield from './icons/Shield.svg?react';
import Signature from './icons/Signature.svg?react';
import Sliders from './icons/Sliders.svg?react';
import SmileyHappy from './icons/SmileyHappy.svg?react';
import SmileyNeutral from './icons/SmileyNeutral.svg?react';
import SmileySad from './icons/SmileySad.svg?react';
import Sort from './icons/Sort.svg?react';
import SortArrows from './icons/SortArrows.svg?react';
import SortDown from './icons/SortDown.svg?react';
import SortRight from './icons/SortRight.svg?react';
import SortUp from './icons/SortUp.svg?react';
import Split from './icons/Split.svg?react';
import StarEmpty from './icons/StarEmpty.svg?react';
import StarFilled from './icons/StarFilled.svg?react';
import StarHalf from './icons/StarHalf.svg?react';
import Stars from './icons/Stars.svg?react';
import Strikethrough from './icons/Strikethrough.svg?react';
import Subscript from './icons/Subscript.svg?react';
import Superscript from './icons/Superscript.svg?react';
import Table from './icons/Table.svg?react';
import Task from './icons/Task.svg?react';
import Tasks from './icons/Tasks.svg?react';
import ThumbsDown from './icons/ThumbsDown.svg?react';
import ThumbsDownComment from './icons/ThumbsDownComment.svg?react';
import ThumbsUp from './icons/ThumbsUp.svg?react';
import Translate from './icons/Translate.svg?react';
import TriangleDown from './icons/TriangleDown.svg?react';
import TriangleLeft from './icons/TriangleLeft.svg?react';
import TriangleRight from './icons/TriangleRight.svg?react';
import TriangleUp from './icons/TriangleUp.svg?react';
import Trophy from './icons/Trophy.svg?react';
import Underline from './icons/Underline.svg?react';
import Undo from './icons/Undo.svg?react';
import Unlock from './icons/Unlock.svg?react';
import Upload from './icons/Upload.svg?react';
import Video from './icons/Video.svg?react';
import Watch from './icons/Watch.svg?react';
import ZoomIn from './icons/ZoomIn.svg?react';
import ZoomOut from './icons/ZoomOut.svg?react';

export const Icons = {
  'add-contact': AddContact,
  alert: Alert,
  'alert-fat': AlertFat,
  'align-center': AlignCenter,
  'align-justify': AlignJustify,
  'align-left': AlignLeft,
  'align-right': AlignRight,
  archive: Archive,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  'bar-chart': BarChart,
  bell: Bell,
  'bell-strikethrough': BellStrikethrough,
  'bid-submitted-with-boq': BidSubmittedWithBoQ,
  'bid-up-to-date': BidUpToDate,
  bold: Bold,
  bookmark: Bookmark,
  briefcase: Briefcase,
  bulb: Bulb,
  'bullet-list': BulletList,
  calendar: Calendar,
  camera: Camera,
  certificate: Certificate,
  check: Check,
  'check-circle': CheckCircle,
  'check-fat': CheckFat,
  checkmark: Checkmark,
  'chevron-down': ChevronDown,
  'chevron-down-up': ChevronDownUp,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'chevron-up-down': ChevronUpDown,
  clipboard: Clipboard,
  clock: Clock,
  close: Close,
  'close-fat': CloseFat,
  'company-logo': CompanyLogo,
  copy: Copy,
  cut: Cut,
  delete: Delete,
  'description-fold': DescriptionFold,
  'description-unfold': DescriptionUnfold,
  diamond: Diamond,
  'document-check': DocumentCheck,
  'double-check': DoubleCheck,
  download: Download,
  'drag-handle': DragHandle,
  edit: Edit,
  email: Email,
  'email-open': EmailOpen,
  empty: Empty,
  euro: Euro,
  'exclamation-fat': ExclamationFat,
  'external-link': ExternalLink,
  eye: Eye,
  'eye-off': EyeOff,
  file: File,
  'file-euro': FileEuro,
  'file-plus': FilePlus,
  'file-text': FileText,
  filter: Filter,
  folder: Folder,
  'folder-opened': FolderOpened,
  'formal-check': FormalCheck,
  gavel: Gavel,
  gift: Gift,
  globe: Globe,
  'graph-up': GraphUp,
  'hard-drive': HardDrive,
  help: Help,
  house: House,
  ignore: Ignore,
  image: Image,
  import: Import,
  'indent-decrease': IndentDecrease,
  'indent-increase': IndentIncrease,
  info: Info,
  italic: Italic,
  library: Library,
  'line-spacing': LineSpacing,
  link: Link,
  location: Location,
  lock: Lock,
  'magic-wand': MagicWand,
  marketplace: Marketplace,
  'marketplace-active': MarketplaceActive,
  'math-operations': MathOperations,
  'math-operations-filled': MathOperationsFilled,
  maximize: Maximize,
  merge: Merge,
  message: Message,
  minus: Minus,
  'minus-fat': MinusFat,
  more: More,
  move: Move,
  navigation: Navigation,
  'numbered-list': NumberedList,
  paperclip: Paperclip,
  payment: Payment,
  people: People,
  person: Person,
  phone: Phone,
  play: Play,
  plus: Plus,
  position: Position,
  printer: Printer,
  'profile-id-card': ProfileIdCard,
  project: Project,
  refresh: Refresh,
  reset: Reset,
  'rocket-launch': RocketLaunch,
  'rounded-square': RoundedSquare,
  search: Search,
  'settings-filled': SettingsFilled,
  'settings-outline': SettingsOutline,
  share: Share,
  shield: Shield,
  signature: Signature,
  sliders: Sliders,
  'smiley-happy': SmileyHappy,
  'smiley-neutral': SmileyNeutral,
  'smiley-sad': SmileySad,
  sort: Sort,
  'sort-arrows': SortArrows,
  'sort-down': SortDown,
  'sort-right': SortRight,
  'sort-up': SortUp,
  split: Split,
  'star-empty': StarEmpty,
  'star-filled': StarFilled,
  'star-half': StarHalf,
  stars: Stars,
  strikethrough: Strikethrough,
  subscript: Subscript,
  superscript: Superscript,
  table: Table,
  task: Task,
  tasks: Tasks,
  'thumbs-down': ThumbsDown,
  'thumbs-down-comment': ThumbsDownComment,
  'thumbs-up': ThumbsUp,
  translate: Translate,
  'triangle-down': TriangleDown,
  'triangle-left': TriangleLeft,
  'triangle-right': TriangleRight,
  'triangle-up': TriangleUp,
  trophy: Trophy,
  underline: Underline,
  undo: Undo,
  unlock: Unlock,
  upload: Upload,
  video: Video,
  watch: Watch,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
  publish: Publish,
} as const;

export type IconKeys = keyof typeof Icons;

// Icons have `pointer-events: none` set in CSS, meaning that most event
// handlers like `onClick` will not do anything. It appears safer to therefore
// disable all handlers.
//
// Use `IconInteractable` for basic interactions or `IconClickable` when
// specifically needing to handle mouse events.
export interface IconProps extends React.SVGAttributes<SVGSVGElement> {
  type: IconKeys;
  size?: number;
  color?: COLOR;
  style?: React.CSSProperties;
}

export const DEFAULT_ICON_SIZE = 16;

const Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ type, size = DEFAULT_ICON_SIZE, color, style, ...props }, ref) => {
    const Component = Icons[type];

    return (
      <Component
        data-icon
        data-cy-icon={type}
        width={size}
        height={size}
        style={{ pointerEvents: 'none', color, flexShrink: 0, ...style }}
        ref={ref}
        {...props}
      />
    );
  },
);

Icon.displayName = 'Icon';

export default Icon;
